module.exports = __webpack_public_path__ + "static/media/kamal_s.89f5ec2d.png";